export default "__VITE_ASSET__eHpI1J8U__"